/* ---------------------------------------------------------------------------
   BLOOMEX NZ — PDP recipe block: keep the visible panel in step with the size.

   Design notes:

   This script only ever READS the selection. It never sets .checked and never
   dispatches a synthetic change, because driving another component's state from
   outside is how the equivalent script broke on a Dawn store: the picker there
   upgraded to a custom element after DOMContentLoaded and silently discarded
   anything set before it did.

   It also does not reference any Prestige class or custom element. It matches a
   checked radio to a panel by comparing the radio's LABEL TEXT to the tier names
   the metafield already gave us. If Maestrooo renames a class in the next theme
   release, this keeps working.

   Progressive enhancement: with JavaScript off, every panel is visible and each
   is labelled with its size. The .is-synced class is what collapses that down.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  var ROOT = '[data-blx-recipe]';

  function labelTextFor(input) {
    var text = '';
    if (input.id) {
      var byFor = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
      if (byFor) text = byFor.textContent;
    }
    if (!text) {
      var wrapping = input.closest('label');
      if (wrapping) text = wrapping.textContent;
    }
    return text.replace(/\s+/g, ' ').trim();
  }

  function sync(root) {
    var panels = root.querySelectorAll('[data-blx-tier]');
    if (!panels.length) return;

    // Single-tier products have nothing to switch between.
    if (panels.length === 1) {
      root.classList.add('is-synced');
      panels[0].removeAttribute('data-blx-inactive');
      panels[0].classList.add('is-active');
      return;
    }

    var names = {};
    Array.prototype.forEach.call(panels, function (p) {
      names[p.getAttribute('data-blx-tier').toLowerCase()] = p;
    });

    // Search the whole document: on Prestige the picker is not necessarily a
    // DOM ancestor or sibling of this block.
    var checked = document.querySelectorAll('input[type="radio"]:checked');
    var target = null;

    for (var i = 0; i < checked.length; i++) {
      var text = labelTextFor(checked[i]).toLowerCase();
      if (!text) continue;
      if (names[text]) { target = names[text]; break; }
      // The tile markup appends a price delta, e.g. "Deluxe +$10.00".
      for (var key in names) {
        if (Object.prototype.hasOwnProperty.call(names, key) && text.indexOf(key) === 0) { target = names[key]; break; }
      }
      if (target) break;
    }

    // Nothing matched: leave every panel visible rather than showing the wrong
    // one. A shopper seeing all three sizes is a cosmetic problem; a shopper
    // seeing Supersize contents priced as Regular is not.
    if (!target) {
      root.classList.remove('is-synced');
      Array.prototype.forEach.call(panels, function (p) {
        p.removeAttribute('data-blx-inactive');
        p.classList.add('is-active');
      });
      return;
    }

    root.classList.add('is-synced');
    Array.prototype.forEach.call(panels, function (p) {
      if (p === target) {
        p.removeAttribute('data-blx-inactive');
        p.classList.add('is-active');
      } else {
        p.setAttribute('data-blx-inactive', '');
        p.classList.remove('is-active');
      }
    });
  }

  function syncAll() {
    var roots = document.querySelectorAll(ROOT);
    Array.prototype.forEach.call(roots, sync);
  }

  // Any change anywhere in the document re-syncs. Cheap, and immune to the
  // picker being re-rendered by the Section Rendering API.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') syncAll();
  }, true);

  // Prestige and Shopify both emit variant events; harmless if they never fire.
  ['variant:change', 'variant:changed', 'product:variant-change'].forEach(function (name) {
    document.addEventListener(name, syncAll);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  // The picker may upgrade after first paint and move the checked state.
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(syncAll);
  });

  // If the section is re-rendered, pick the new block up.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () { pending = false; syncAll(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
